export enum ContractSegmentSectionsEnums {
	PROGRAMME = 'programme',
	STUDENT = 'student',
	ATTRIBUTION = 'attribution',
	PRICING = 'pricing',
	COMMENTS = 'comments'
}
